export function visibleDisplayName(user, participant, project){
	if( !participant ){
		return ""
	}
	if( user.role == 'admin' ){
		return participant.displayName;
	}
	if( user.role == 'client' ){
		var userID = user.uid;
		var permissions = project.permissions;
		if( project.hideContactDetails ){
			return participant.firstName;
		}
		if( !permissions || !permissions[userID] ){
			return "";
		}
		if( permissions[userID].moderate ){
			return participant.displayName;
		}
		else{
			return participant.firstName
		}
	}
	else{
		return ""
	}
}
export function visibleContacts(user, participant, project, key){
	if( user.role == 'admin' ){
		return true;
	}
	if( user.role == 'client' ){
		var userID = user.uid;
		var permissions = project.permissions;
		if( !permissions || !permissions[userID] ){
			return false;
		}
		if( permissions[userID].moderate ){
			return participant[key];
		}
		else{
			return false;
		}
	}
	else{
		return false
		
	}
}

export function allowComms(user, project){
	if( user.role == 'admin' ){
		return true;
	}
	if( user.role == 'client' ){
		var userID = user.uid;
		var permissions = project.permissions;
		if( !permissions || !permissions[userID] ){
			return false;
		}
		if( permissions[userID].moderate ){
			return true;
		}
		else{
			return false;
		}
	}
	else{
		return false
		
	}
}
